import axios from "axios";
import {
  registerRequestInterceptor,
  setupInterceptors,
  registerBrowserInterceptor,
} from "./interceptors";

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 20000, // 20 seconds timeout
  headers: {
    "Content-Type": "application/json",
  },
});

registerRequestInterceptor(apiClient);
setupInterceptors(apiClient);
registerBrowserInterceptor(apiClient);
